import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Button from "../Button";
import SupplierForm from "./SupplierForm";
import {SUPPLIERS_LIST} from "./SupplierTypeSelect";
import {useDispatch} from "react-redux";
import {updateSupplier} from "../../reducers/suppliers/actions";
import {useTranslation} from "react-i18next";

const SupplierEditModal = props => {
  const { t } = useTranslation('suppliers_modal')
  const dispatch = useDispatch();
  const ref = React.createRef();
  const [saving, setSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  const handleSave = supplier => {
    setIsSaved(true);
    dispatch(updateSupplier(supplier));
    props.onClose();
  };

  const handleClose = () => {
    if (!isSaved && window.Intercom) {
      window.Intercom('showNewMessage', t('intercom_help_message', {supplierName: SUPPLIERS_LIST.find(_supplier => _supplier.value === props.supplier.type)?.name ?? props.supplier.type}));
    }
    props.onClose();
  };

  return (
    <Modal isOpen size={'lg'} toggle={handleClose}>
      <ModalHeader toggle={handleClose}>{t('integration_edit_modal.header')}</ModalHeader>
      <ModalBody>
        <img className="d-block mx-auto mb-3" src={SUPPLIERS_LIST.find(_supplier => _supplier.value === props.supplier.type).logo} style={{ maxHeight: 65 }} />

        <SupplierForm
          ref={ref}
          submitButton={false}
          supplierSelectHidden
          data={props.supplier}
          onSavingStart={() => setSaving(true)}
          onSavingStop={() => setSaving(false)}
          onSaved={handleSave}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={handleClose}>{t('common:btn.cancel')}</Button>
        <Button
          loading={saving}
          onClick={() => ref.current.onSubmit()}
        >
          <i className="fas fa-save" />
          <span>{t('common:btn.save')}</span>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

SupplierEditModal.propTypes = {
  supplier: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SupplierEditModal;